var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-back",on:{"click":_vm.goBack}},[_c('back-icon'),_c('p',{staticClass:"widget-back--label"},[_vm._v(_vm._s(_vm.i18n.global.t("back")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }